import { Link } from 'react-router-dom';

export default function Segments() {
  const segments = [
    {
      id: 'primary',
      title: '小学版块',
      subtitle: 'AI 趣味体验与感知',
      grade: '1-6年级',
      color: 'pink',
      icon: 'ri-palette-line',
      description: '通过有趣的互动体验,让小朋友们感知AI的神奇魅力',
      features: [
        { icon: 'ri-brush-line', name: '神奇画板', desc: '涂鸦变画作' },
        { icon: 'ri-robot-line', name: '智能对话小伴侣', desc: '语音互动学习' },
        { icon: 'ri-eye-line', name: '慧眼识万物', desc: '物体识别体验' },
        { icon: 'ri-quill-pen-line', name: '作文润色助手', desc: '智能写作指导' },
        { icon: 'ri-route-line', name: '生活算法沙箱', desc: '算法游戏化学习' }
      ],
      path: '/primary'
    },
    {
      id: 'middle',
      title: '初中版块',
      subtitle: 'AI 原理透视与应用',
      grade: '7-9年级',
      color: 'blue',
      icon: 'ri-flask-line',
      description: '理解机器学习、神经网络原理,使用低代码工具创建AI应用',
      features: [
        { icon: 'ri-brain-line', name: '神经网络实验室', desc: '3D可视化学习' },
        { icon: 'ri-robot-2-line', name: '智能体搭建工坊', desc: '低代码创建AI' },
        { icon: 'ri-team-line', name: '跨学科项目空间', desc: '团队协作创新' },
        { icon: 'ri-wifi-line', name: 'IoT联动模拟器', desc: 'AI+物联网' },
        { icon: 'ri-line-chart-line', name: '机器学习游乐场', desc: '模型训练体验' }
      ],
      path: '/middle'
    }
  ];

  const colorMap: Record<string, { bg: string; text: string; border: string; gradient: string }> = {
    pink: { bg: 'bg-pink-50', text: 'text-pink-600', border: 'border-pink-200', gradient: 'from-pink-500 to-pink-600' },
    blue: { bg: 'bg-blue-50', text: 'text-blue-600', border: 'border-blue-200', gradient: 'from-blue-500 to-indigo-600' }
  };

  return (
    <section id="segments" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full mb-6">
            <i className="ri-graduation-cap-line"></i>
            <span className="text-sm font-semibold">LEARNING SEGMENTS</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            学段入口
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            根据不同学段特点,提供差异化的AI学习体验,实现螺旋上升式成长
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {segments.map((segment) => {
            const colors = colorMap[segment.color];
            return (
              <div key={segment.id} className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all">
                <div className={`${colors.bg} p-8 border-b-4 ${colors.border}`}>
                  <div className={`w-16 h-16 bg-white rounded-2xl flex items-center justify-center mb-4 shadow-lg`}>
                    <i className={`${segment.icon} text-4xl ${colors.text}`}></i>
                  </div>
                  <div className={`inline-block ${colors.bg} border ${colors.border} px-3 py-1 rounded-full text-xs font-semibold ${colors.text} mb-3`}>
                    {segment.grade}
                  </div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-2">{segment.title}</h3>
                  <p className="text-lg font-semibold text-gray-700 mb-3">{segment.subtitle}</p>
                  <p className="text-gray-600">{segment.description}</p>
                </div>

                <div className="p-8">
                  <div className="space-y-4 mb-8">
                    {segment.features.map((feature, index) => (
                      <div key={index} className="flex items-start space-x-3">
                        <div className={`w-10 h-10 ${colors.bg} rounded-lg flex items-center justify-center flex-shrink-0`}>
                          <i className={`${feature.icon} text-xl ${colors.text}`}></i>
                        </div>
                        <div>
                          <div className="font-semibold text-gray-900">{feature.name}</div>
                          <div className="text-sm text-gray-600">{feature.desc}</div>
                        </div>
                      </div>
                    ))}
                  </div>

                  <Link 
                    to={segment.path}
                    className={`w-full px-8 py-3 bg-gradient-to-r ${colors.gradient} text-white rounded-lg font-semibold transition-all hover:shadow-lg flex items-center justify-center space-x-2 whitespace-nowrap cursor-pointer`}
                  >
                    <span>进入{segment.title.substring(0, 2)}端</span>
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
